import React, { useEffect, useRef, useState } from 'react';
import '../styles/madmovie.css';
import jirachiImage from '../img/jirachi-Photoroom.png'; // Import the image
import axios from 'axios';
import confetti from 'canvas-confetti';
import LunchRecommend from '../components/LunchRecommend';
import AddCategoryAndMenu from '../components/AddCategoryAndMenu';

const MadMovie = () => {
  const [selectedMenu, setSelectedMenu] = useState('버튼을 눌러주세요!');
  const [menus,setMenus] = useState(['']);
  const [loading, setLoading] = useState(true);
  const [countdown, setCountdown] = useState(null);

  // Section Component for better organization
  const Section = ({ title, children, onMouseMove, onMouseLeave }) => (
    <section className="mad-movie-section" onMouseMove={onMouseMove} onMouseLeave={onMouseLeave}>
      <h2 style={{marginBottom:30}}>{title}</h2>
      {children}
    </section>
  );

  const cardRef = useRef(null);

  const handleMouseMove = (e) => {
    const card = cardRef.current;
    if (!card) return;

    const { clientX, clientY } = e;
    const { left, top, width, height } = card.getBoundingClientRect();

    const x = clientX - left;
    const y = clientY - top;

    // Card tilt effect
    const rotateX = (y - height / 2) / (height / 2) * -8; 
    const rotateY = (x - width / 2) / (width / 2) * 8;  
    card.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(1.1)`;

    // Hologram shine effect
    const angle = Math.atan2(y - height / 2, x - width / 2) * (180 / Math.PI) - 90;
    card.style.setProperty('--angle', `${angle}deg`);
    card.style.setProperty('--mouse-x', `${(x / width) * 100}%`);
    card.style.setProperty('--mouse-y', `${(y / height) * 100}%`);
  };

  const handleMouseLeave = () => {
    const card = cardRef.current;
    if (card) {
      card.style.transform = 'rotateX(0deg) rotateY(0deg) scale(1)';
    }
  };

  return (
    <div className="mad-movie-scroll-container">
      <Section 
        title="포켓몬 카드 인터랙션" 
        onMouseMove={handleMouseMove} 
        onMouseLeave={handleMouseLeave}
      >
        <div className="interactive-card" ref={cardRef}>
          <div className="card-header">요런거 본적 있어 ?</div>
          <div className="card-image-container">
            <img src={jirachiImage} alt="Jirachi" className="card-image" />
          </div>
          <div className="card-description">
            귀여운 지라치!
            마우스를 갖다대고 이리저리 움직여보세요 ! ㅎㅎ 
          </div>
        </div>
      </Section>

      <Section title="점메추 뽑기 기계">
        <LunchRecommend/>
      </Section>

      <Section title="점메추 메뉴 추가하기~">
        <AddCategoryAndMenu/>
      </Section>
    </div>
  );
};

export default MadMovie;